import { render } from "./MoneyHubLinkPage.vue?vue&type=template&id=0aae0532&scoped=true"
import script from "./MoneyHubLinkPage.vue?vue&type=script&lang=js"
export * from "./MoneyHubLinkPage.vue?vue&type=script&lang=js"

import "./MoneyHubLinkPage.vue?vue&type=style&index=0&id=0aae0532&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aae0532"]])

export default __exports__